var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      class: ["my-common-modal", _vm.className],
      attrs: {
        modal: false,
        visible: _vm.myVisible,
        "append-to-body": true,
        title: _vm.title,
        "before-close": _vm.handleClose,
        top: "0vh",
        width: _vm.width
      },
      on: {
        "update:visible": function($event) {
          _vm.myVisible = $event
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }